// import { format } from 'path';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DipStateService } from 'app/services/dip-state-service.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, FormArray } from '@angular/forms';
import { TogetherDIPStage, TogetherDIPStageContainer } from 'app/models/app.models';
import { SubmissionRequestStatus } from 'app/models/enums';

@Component({
    selector: 'dip-overview',
    templateUrl: './dip-overview.component.html',
    styleUrls: ['./dip-overview.component.scss'],
    standalone: false
})
export class DipOverviewComponent {
    /**
     * Current stage.
     * TODO: Move out into service.
     *
     * @type {TogetherDIPStageContainer}
     * @memberof DipOverviewComponent
     */
    @Input() stage: TogetherDIPStageContainer;

    /**
     * Output for stage changing.
     * TODO: Move out into service.
     *
     * @type {EventEmitter<string>}
     * @memberof DipOverviewComponent
     */
    @Output() stageChanging: EventEmitter<string> = new EventEmitter<string>();

    /**
     * The id of the case geing processed
     *
     * @type {string}
     * @memberof DipOverviewComponent
     */
    @Input() caseId: string;

    /**
     * Have they agreed to the terms on the page?
     *
     * @type {FormControl}
     * @memberof DipOverviewComponent
     */
    termsAgreed: UntypedFormControl = new UntypedFormControl(null, [
        Validators.requiredTrue,
    ]);


    /**
     * The form for the overview page.
     *
     * @type {FormGroup}
     * @memberof DipOverviewComponent
     */
    dipOverviewForm: UntypedFormGroup = new UntypedFormGroup({
        termsAgreed: this.termsAgreed,
        recapForm: new UntypedFormGroup({
            default: new UntypedFormControl(null, [Validators.required]),
        }),
    });

    /**
     * Is the page loading?
     *
     * @readonly
     * @type {boolean}
     * @memberof DipOverviewComponent
     */
    get isPageLoading(): boolean {
        return this.state.IsLoading;
    }

    /**
     * Receives the recap form and its components validity from many miles away.
     *
     * @param {any} form
     * @memberof DipOverviewComponent
     */
    receiveRecapForm(form) {
        this.dipOverviewForm.removeControl('recapForm');
        this.dipOverviewForm.addControl('recapForm', form as UntypedFormGroup);
    }

    /**
      * Handles moving forward.
      *
      * @param {any} forward
      * @memberof TogetherAuctionDIPLoanDetailComponent
      */
    onForwardClicked(forward) {
        if (this.dipOverviewForm.invalid) {
            return false;
        }
        // FLag that it is OK to submit the DIP.
        this.state.dipSubmissionStatus = SubmissionRequestStatus.Initialised;
        this.stageChanging.emit(this.stage.forward_stage.reference);
    }

    /**
     * Handles move backward.
     *
     * @param {any} backward
     * @memberof TogetherAuctionDIPLoanDetailComponent
     */
    onBackwardClicked(backward) {
        this.stageChanging.emit(this.stage.backward_stage.reference);
    }

    /**
     * Go to stage.
     * TODO: Move out into service.
     *
     * @param {any} stage
     * @memberof DipOverviewComponent
     */
    gotoStage(stage) {
        this.stageChanging.emit(stage);
    }

    /**
     * Creates an instance of DipOverviewComponent.
     * @param {DipStateService} state
     * @memberof DipOverviewComponent
     */
    constructor(private state: DipStateService, private fb: UntypedFormBuilder) { }
}
